<template>
  <in-viewport>
    <div class="map-section">
      <base-layout hide-sidebar>
        <border-box slot="sidebar"><h2 v-html="heading"/></border-box>
        <div slot="content">
          <border-box>
            <grid-row>
              <div class="map-section__map">
                <gmap-map
                  :options="options"
                  :center="options.center"
                  class="map-section__map-item"
                >
                  <gmap-marker :position="markerPosition"/>
                </gmap-map>
              </div>
            </grid-row>
          </border-box>
        </div>
      </base-layout>
    </div>
  </in-viewport>
</template>

<script>
import BaseLayout from '@/components/BaseLayout'
import BorderBox from '@/components/BorderBox'

import styles from '@/assets/js/mapStyles'

const MAP_CONFIG = {
  zoom: 15,
  styles: styles,
  center: { lat: 52.2046176, lng: 21.0219807 }
}

export default {
  components: {
    BaseLayout,
    BorderBox
  },
  props: {
    heading: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      options: MAP_CONFIG,
      markerPosition: { lat: 52.204654, lng: 21.022544 }
    }
  }
}
</script>

<style lang="scss" scoped>
  .map-section {
    @include vertical-space((bottom: 0), padding);

    @include media-up(md) {
      @include vertical-space((bottom: 3))
    }

    &__map {
      @include vertical-space((top: 1), padding);
      @include grid-column((xs: 12));
      height: 16 * $vertical-space;
      max-height: 100vh;

      @include media-down(md) {
        padding: 0;
      }

      @include media-up(md) {
        height: 24 * $vertical-space;
      }

      @include media-up(lg) {
        @include nested-column-width(8, 9, lg);
        margin-top: -8px;
      }

      &-item {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Contact/MapSection.vue